var HttpStatus = /*#__PURE__*/function (HttpStatus) {
  HttpStatus[HttpStatus["Ok"] = 200] = "Ok";
  HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
  HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
  return HttpStatus;
}(HttpStatus || {});
var HttpStatus$1 = HttpStatus;

export { HttpStatus$1 as default };
//# sourceMappingURL=httpStatus.js.map
